<template>
    <div class="container-fluid" v-if="tracker && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vue-tabs active-tab-color="#2c3e50" active-text-color="white">

            <v-tab title="INICIAL">
                <br/>
                <positions-maps :posicao="posicao"/>
            </v-tab>

            <v-tab title="PROBLEMAS" v-if="veiculo">
                <br/>
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </v-tab>

            <v-tab title="CLIENTE" v-if="cliente">
                <div class="row">
                    <form-cliente :cliente="cliente"  :edit="false" :showFinanceiro="false"/>
                </div>
                <div class="row">
                    <table-telefones-clientes :height="null" :telefones="cliente.telefones" :edit="false"></table-telefones-clientes>
                </div>
            </v-tab>

            <v-tab title="OBS" v-if="veiculo">
                <br/>
                <label for="hora_inicial_noturno" class="col-sm-6 control-label">OBS DO VEÍCULO:</label>
                <textarea v-model="veiculo.obs" style="height: 200px !important;" class="form-control"></textarea>
            </v-tab>

            <v-tab title="HISTÓRICO">
                <br/>
                <relatorio-periodo :id_rastreador="rastreador.id_rastreador"/>
            </v-tab>

            <v-tab title="ALERTAS" v-if="veiculo">
                <br/>
                <relatorio-alertas :uuid="veiculo.uuid"/>
            </v-tab>

            <v-tab title="RELATÓRIOS" v-if="veiculo">
                <br/>
                <relatorios :uuid="veiculo.uuid" :id_cliente="veiculo.id_cliente"></relatorios>
            </v-tab>

            <v-tab title="COMANDOS" v-if="rastreador">

                <br/>

                <div class="col-sm-3">
                    <enviar-saidas :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </v-tab>

        </vue-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1><br/><br/><br/>
        </center>
    </div>
</template>
<script>
    import MenuSuperior from '../../components/MenuSuperior.vue';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import {Rastreador, Suntech } from '../../class';
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import Relatorios from '../veiculo/Relatorios';
    import RelatorioPeriodo from '../relatorios/RelatorioPeriodo';
    import HeaderAdmin from "./HeaderAdmin";
    import RelatorioAlertas from "../relatorios/RelatorioAlertas";
    import Problemas from "../veiculo/Problemas";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import FormCliente from '../forms/FormCliente';
    import TableTelefonesClientes from '../tables/TableTelefonesClientes';
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import PositionsMaps from './partials/PositionsMaps.vue';

    export default {
        components: {
            PositionsMaps,
            TableTelefonesClientes,
            FormCliente,
            Problemas,
            RelatorioAlertas,
            HeaderAdmin,
            MenuSuperior, Reset, TableComandos,
            SolicitarConfiguracao, EnviarSaidas, Relatorios,
            RelatorioPeriodo,
        },

        data(){
            return {
                config: null
            }
        },

        mixins: [
            veiculosAdminMixins
        ],

        async beforeMount(){
            this.config = await Suntech.byPK(this.rastreador.id_rastreador);
        },
    }
</script>
